/**
 * Validação e conversão do formulário da etapa 1 do cadastro de instalação com inflamáveis.
 */
import {
  FLAMMABLE_ACTIVITY_TYPES,
  type FlammableInstallationCreateData,
} from '../../../../types/flammableInstallation';
import type { IdentificationErrors, IdentificationValues } from './FlammableInstallationWizard.types';

const blankToNull = (value: string): string | null => {
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
};

export function validateIdentification(
  values: IdentificationValues,
  requiresCompany = false
): IdentificationErrors {
  const errors: IdentificationErrors = {};

  if (requiresCompany && values.companyId === '') errors.companyId = 'Escolha a empresa dona da instalação.';

  if (values.name.trim() === '') errors.name = 'Diga o nome da instalação.';
  else if (values.name.trim().length > 255) errors.name = 'O nome pode ter até 255 letras.';

  if (values.tag.trim().length > 100) errors.tag = 'Use até 100 letras.';
  if (values.location.length > 255) errors.location = 'Use até 255 letras.';

  if (values.activityType === '' || !FLAMMABLE_ACTIVITY_TYPES.includes(values.activityType)) {
    errors.activityType = 'Escolha a atividade da instalação.';
  } else if (values.activityType === 'OUTRA' && values.activityDescription.trim() === '') {
    errors.activityDescription = 'Descreva a atividade, porque você escolheu "Outra".';
  }

  return errors;
}

/**
 * `includeCompany` é falso na atualização: a empresa dona não muda depois que a instalação é salva.
 * A atividade chega validada (`validateIdentification` barra o vazio antes).
 */
export function identificationToPayload(
  values: IdentificationValues,
  includeCompany = true
): FlammableInstallationCreateData {
  if (values.activityType === '') throw new Error('Escolha a atividade da instalação.');

  return {
    ...(!includeCompany || values.companyId === '' ? {} : { companyId: Number(values.companyId) }),
    name: values.name.trim(),
    tag: blankToNull(values.tag),
    activityType: values.activityType,
    activityDescription: values.activityType === 'OUTRA' ? values.activityDescription.trim() : null,
    location: blankToNull(values.location),
    departmentId: values.departmentId === '' ? null : Number(values.departmentId),
    status: values.status,
    observations: blankToNull(values.observations),
  };
}
